import { useMemo, useState } from 'react';
import { SectionLoading } from '../shared/SectionLoading';
import { ConnectorCard } from './Connectors/ConnectorCard';
import { MELPumpModal } from './Connectors/MELPumpModal';
import { ConfirmDelete } from '../shared/ConfirmDelete';
import { MELPumpTokenName } from '../../constants/common';
import { useNotification } from '../../hooks/useNotifications';
import useOrganisationTokens from '../../data/organisation/useOrganisationTokens';
import useOrganisationTokenMutations from '../../data/organisation/useOrganisationTokenMutations';
import useOrganisation from '../../data/organisation/useOrganisation';

export function ConnectorsTab() {
  const { organisationTokens } = useOrganisationTokens();
  const { remove } = useOrganisationTokenMutations();
  const { organisation } = useOrganisation();
  const addNotification = useNotification();
  const [melPumpConnectOpen, setMelPumpConnectOpen] = useState(false);
  const [melPumpDisconnectConfirmOpen, setMelPumpDisconnectConfirmOpen] =
    useState(false);

  const hasConnectedMELPump = useMemo(() => {
    if (organisationTokens.data) {
      return organisationTokens.data.some(
        (token) => token.tokenName === MELPumpTokenName
      );
    }

    return false;
  }, [organisationTokens.data]);

  const disconnectMELPump = () => {
    const melPumpToken = organisationTokens.data?.find(
      (token) => token.tokenName === MELPumpTokenName
    );

    if (melPumpToken) {
      remove.mutate(melPumpToken.id, {
        onSuccess: () => {
          addNotification('success', 'MEL Pump disconnected successfully');
        },
        onError: () => {
          addNotification('error', 'Failed to disconnect MEL Pump');
        },
      });
    } else {
      addNotification('error', 'Failed to disconnect MEL Pump');
    }

    setMelPumpDisconnectConfirmOpen(false);
  }

  return (
    <>
      <MELPumpModal
        open={melPumpConnectOpen}
        onClose={() => setMelPumpConnectOpen(false)}
      />
      <ConfirmDelete
        title="Confirm Disconnect"
        description="Are you sure you want to disconnect MEL Pump? Any integrations will stop working"
        open={melPumpDisconnectConfirmOpen}
        onCancel={() => setMelPumpDisconnectConfirmOpen(false)}
        onConfirm={disconnectMELPump}
      />
      <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
        <div>
          <h2 className="text-2xl font-semibold leading-7 text-primary">
            Connectors
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-900 dark:text-gray-200">
            View and manage your connections to third party services.
          </p>
          {organisationTokens.isLoading || organisation.isLoading ? (
            <SectionLoading />
          ) : (
            <div className="mt-6 space-y-6 divide-y divide-gray-300 border-t border-gray-400 text-sm leading-6 dark:divide-gray-600 dark:border-gray-500">
              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <ConnectorCard
                  logoUrl="https://melpump.com/img/logo.png"
                  connectorName="MEL Pump"
                  connected={hasConnectedMELPump}
                  onToggle={hasConnectedMELPump ? () => setMelPumpDisconnectConfirmOpen(true) : () => setMelPumpConnectOpen(true)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
